import { sendUtagEvent } from '../../core/analytics/utag_events'
import on from '../../utils/events_delegation'
import { getCleanedString } from '../../utils/utilities'

const isStaMicrosite = document.querySelector('html').dataset.inMicrosite === 'star_agents'
const isIbeProMicrosite = document.querySelector('html').dataset.inMicrosite === 'iberostar_pro'
const purposeValue = isStaMicrosite ? 'loyalty' : 'information'
let isUtagEventInitialized = false

function field_form_event(form_type, form_name, form_action, field_name, event_name = '', event_purpose) {
  // We need to rename the mice form to rfp
  const formName = form_name === 'mice form' ? 'rfp' : form_name

  sendUtagEvent({
    data: {
      event_name,
      event_cat: form_type,
      event_act: `${form_action}-${formName}`,
      event_lbl: getCleanedString(field_name),
      event_purpose: event_purpose ? event_purpose : purposeValue,
      event_structure: 'body',
    },
  })
}

function error_form_event(form_name, form_action, field_name, form) {
  const form_type =
    form.dataset.formType === undefined || form.dataset.formType === 'rfp' ? 'form' : form.dataset.formType
  const formName = form.dataset.formType === 'rfp' ? 'rfp' : form_name
  const allPurposeValue = formName === 'reservations' ? 'postbooking' : purposeValue

  sendUtagEvent({
    data: {
      event_name: 'error_form',
      event_cat: form_type,
      event_act: `${form_action}-${formName}`,
      event_lbl: getCleanedString(field_name),
      event_purpose: allPurposeValue,
      event_structure: 'body',
    },
  })
}

function start_form_event(form_name, form_action, field_name, form) {
  const form_is_sent = form.classList.contains('form-sent')
  const form_type =
    form.dataset.formType === undefined || form.dataset.formType === 'rfp' ? 'form' : form.dataset.formType
  const formName = form.dataset.formType === 'rfp' ? 'rfp' : form_name
  const allPurposeValue = formName === 'reservations' ? 'postbooking' : purposeValue

  if (!form_is_sent) {
    const label = field_name.replace('_id', '').replace('iberostar_api_user', '').replace('vo_not_logged_booking', '')
    sendUtagEvent({
      data: {
        event_name: 'start_form',
        event_cat: form_type,
        event_act: `${form_action}-${formName}`,
        event_lbl: getCleanedString(label),
        event_purpose: allPurposeValue,
        event_structure: 'body',
      },
    })
  }
}

function getFormCategory(formName) {
  const categories = {
    'contact form': 'information',
    'login form': 'loyalty',
    'personal information': 'loyalty',
    password: 'loyalty',
    reservations: 'postbooking',
    'lead form': 'loyalty',
    'check in': 'postbooking',
    'booking quote': 'booking',
    'my room online': 'postbooking',
    'call me back': 'information',
    'password form': 'loyalty',
    'postlead form': 'loyalty',
    rfp: 'information',
    'wedding form': 'information',
    'best price form': 'information',
    'agency login': 'information',
    'agency sign in': 'information',
    'agency data': 'information',
    'user agency data': 'information',
    'user data': 'information',
    'membership enquiry': 'information',
  }

  const formNameStr = String(formName)
  const key = formNameStr.replace(/^.*form-/, '').trim()

  return categories[key] || ''
}

// Events after submit form request
export function errorFormResponsEvent(form, labelMessage) {
  const ibeProForm = document.querySelector('.js-ibepro-login-form', '.js-ibepro-register-form')
  const labelValue = isIbeProMicrosite === true && ibeProForm !== null ? labelMessage : ''
  const formName = form.dataset.formName
  const allPurposeValue = formName === 'reservations' ? 'postbooking' : purposeValue

  sendUtagEvent({
    data: {
      event_name: 'error_form',
      event_cat: 'form',
      event_act: `error form-${formName}`,
      event_lbl: labelValue,
      event_purpose: allPurposeValue,
      event_structure: 'body',
    },
  })
}

export function successFormResponsEvent(form) {
  const formName = form.getAttribute('data-form-name')
  const eventAct = `success form-${formName}`
  const eventPurpose = getFormCategory(formName)
  const allPurposeValue = formName === 'reservations' ? 'postbooking' : eventPurpose

  sendUtagEvent({
    data: {
      event_name: 'success_form',
      event_cat: 'form',
      event_act: eventAct,
      event_lbl: '',
      event_purpose: allPurposeValue,
      event_structure: 'body',
    },
  })
}

function normalizeFieldName(name) {
  const nameStr = String(name)
  return nameStr
    .replace('[', '')
    .replace(']', '')
    .replace('iberostar_api_userfirst_name', 'first_name')
    .replace('_', ' ')
}

function getFieldName(custom_field_name, name) {
  let field_name = ''
  if (custom_field_name !== undefined && custom_field_name !== '') {
    field_name = custom_field_name
  } else {
    field_name = name
  }
  return field_name
}

function isVisible(element) {
  return (
    element.offsetWidth > 0 ||
    element.offsetHeight > 0 ||
    getComputedStyle(element).display !== 'none' ||
    element.style.display !== 'none' ||
    element.style.visibility !== 'hidden'
  )
}

export function startFormEvent(input) {
  if (isVisible(input)) {
    const parentForm = input.closest('form')
    const form_name = parentForm.dataset.formName
    const custom_field_name = input.dataset.utagNormalizeFieldName

    switch (input.type) {
      case 'select-multiple':
      case 'select-one':
        input.addEventListener('click', function () {
          start_form_event(
            form_name,
            'start form',
            getFieldName(custom_field_name, normalizeFieldName(input.name)),
            parentForm
          )
          parentForm.classList.add('form-sent')
        })
        break
      case 'text':
      case 'textarea':
      case 'checkbox':
      case 'file':
      case 'radio':
      case 'email':
      case 'password':
      case 'submit':
        if (
          input.type === 'submit' &&
          !(
            form_name === 'collect points' ||
            form_name === 'points statement' ||
            form_name === 'transfer points' ||
            form_name === 'authorize new registrations'
          )
        ) {
          break
        }
        input.addEventListener('click', function () {
          start_form_event(
            form_name,
            'start form',
            getFieldName(custom_field_name, normalizeFieldName(input.name)),
            parentForm
          )
          parentForm.classList.add('form-sent')
        })
        break
    }
  }
}

export function initializeUtagEvents() {
  /* utag-event for click in fasbooking destination input */
  const validSelectors = [
    'form.new_iberostar_api_user_session button.btn-with-arrow',
    'form#new_iberostar_api_user button',
    '#form_validate button',
    '#form_wci button',
    '.utag-register-form',
    'utag-not-logged-form',
    '.utag-form .utag-form-button',
    'button.utag-wedding',
    'button.utag-mice',
    '#form_mro button',
    '.contact-us form button',
    '#personal-info-submit',
  ]

  on({
    eventName: 'submit',
    selector: 'form.wedding-form',
    handler(event) {
      const form = event.target
      if (window.Parsley && $(form).parsley().isValid()) {
        const type_request = form.querySelector('#type_request :checked')?.dataset.utagValue || ''
        const type_event = form.querySelector('#type_event :checked')?.dataset.utagValue || ''
        const country_val = form.querySelector('#country')?.value
        const country = country_val ? getCleanedString(country_val.trim().toLowerCase()) : ''

        const date_day_val = form.querySelector('#date_day :checked')?.value
        const date_month_val = form.querySelector('#date_month :checked')?.value
        const date_year_val = form.querySelector('#date_year :checked')?.value
        const wedding_date =
          date_day_val && date_month_val && date_year_val ? `${date_day_val}/${+date_month_val}/${date_year_val}` : ''

        const destination = form.querySelector('#preferred_destination :checked')?.dataset.utagValue || ''
        const number_guest = form.querySelector('#number_guests')?.value || ''

        const lbl = `${type_request}-${type_event}-${country}-${wedding_date}-${destination}-${number_guest}`

        sendUtagEvent({
          data: {
            event_name: 'quote_wedding',
            event_cat: 'wedding',
            event_act: 'request-event-origin-dd/MM/YYYY-destination-guest',
            event_lbl: lbl,
            event_purpose: 'booking',
            event_structure: 'body',
          },
        })
      }
    },
  })
  if (!isUtagEventInitialized) {
    on({
      eventName: 'click',
      selector: validSelectors,
      handler(event) {
        const target = event.target
        if (validSelectors.some(selector => target.matches(selector))) {
          if (target.matches('.utag-register-form button')) {
            field_form_event(
              'form',
              target.closest('form.utag-form').getAttribute('data-form-name'),
              'try send form',
              '',
              'try_send_form',
              'loyalty'
            )
          } else if (target.matches('.js-reservation-management-button')) {
            field_form_event(
              'form',
              target.closest('form.utag-form').getAttribute('data-form-name'),
              'try send form',
              '',
              'try_send_form',
              'postbooking'
            )
          } else if (target.dataset.tryEnabled === 'false') {
            return
          } else {
            field_form_event(
              'form',
              target.closest('form').getAttribute('data-form-name'),
              'try send form',
              '',
              'try_send_form',
              ''
            )
            if (target.matches('.js-click-button')) target.dataset.tryEnabled = 'false'
          }
        }
      },
    })
  }

  document
    .querySelectorAll('form.mice-hidden-form, form.ibepro-utag-register, form.mice-form, form.staragent-utag-register')
    .forEach(function (form) {
      form.querySelectorAll('input, select, textarea').forEach(function (input) {
        if (input) {
          const parentForm = input.closest('form')
          const form_name = parentForm.dataset.formName
          const custom_field_name = input.dataset.utagNormalizeFieldName

          switch (input.type) {
            case 'select-multiple':
            case 'select-one':
            case 'text':
            case 'textarea':
            case 'checkbox':
            case 'radio':
            case 'email':
            case 'password':
              if (!input.dataset.isUtagEventInitialized) {
                input.addEventListener('click', function () {
                  start_form_event(
                    form_name,
                    'start form',
                    getFieldName(custom_field_name, normalizeFieldName(input.name)),
                    parentForm
                  )
                  parentForm.classList.add('form-sent')
                })
                input.dataset.isUtagEventInitialized = true
              }
              break
          }
        }
      })
    })

  if (!isUtagEventInitialized) {
    try {
      window.Parsley.on('form:validated', function (fieldInstance) {
        const field_error_name = []
        if (
          fieldInstance.element.classList.contains('utag-form') &&
          fieldInstance.element.classList.contains('validate-form')
        ) {
          document.querySelectorAll('.parsley-error, .parsley-error input').forEach(function (element) {
            if (
              !element.hidden ||
              (element.type === 'checkbox' && !element.nextElementSibling.classList.contains('ignore-utag-validation'))
            ) {
              let name
              if (element.dataset.utagError && element.dataset.utagError !== '') {
                name = element.dataset.utagError
              } else if (element.dataset.utagNormalizeFieldName && element.dataset.utagNormalizeFieldName !== '') {
                name = element.dataset.utagNormalizeFieldName
              } else {
                name = element.getAttribute('name')
              }

              if (name !== null && name !== undefined && name !== 'iberostar_api_user[accepts_privacy]') {
                field_error_name.push(
                  name
                    .replace('agent_', '')
                    .replace('comercial_', '')
                    .replace('newslet', '')
                    .replace('vo_not_logged_booking', '')
                    .replace('booking_', '')
                    .replace('iberostar_api_user', '')
                    .replace('billing_', '')
                    .replace('[', '')
                    .replace(']', '')
                    .substring(0, 3)
                )
              }
            }
          })

          // TODO PY05032 - Remove this jQuery when we have a better solution
          if (
            (event.type === 'focusout' || event.type === 'submit') &&
            !$(fieldInstance.element).parsley().isValid() &&
            !fieldInstance.validationResult
          ) {
            const field_error_name_uniq = [...new Set(field_error_name)].sort()
            error_form_event(
              fieldInstance.element.dataset.formName,
              'error form',
              field_error_name_uniq.join('-'),
              fieldInstance.element
            )
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  document
    .querySelectorAll('form.utag-form:not(.mice-quote-form):not(.ibepro-utag-register):not(.staragent-utag-register)')
    .forEach(function (form) {
      form.querySelectorAll('input, select, textarea').forEach(function (input) {
        if (input.dataset.isUtagEventInitialized) return
        startFormEvent(input)
        input.dataset.isUtagEventInitialized = true
      })
    })

  if (!initializeUtagEvents) {
    document.addEventListener('DOMContentLoaded', function () {
      var savePasswordElement = document.querySelector('#save_password')
      savePasswordElement?.addEventListener(
        'change',
        function () {
          sendUtagEvent({
            data: {
              event_name: 'save_password',
              event_cat: 'login',
              event_act: 'save password',
              event_lbl: '',
              event_purpose: 'information',
              event_structure: 'body',
            },
          })
        },
        { once: true }
      )
      isUtagEventInitialized = true
    })
  }

  isUtagEventInitialized = true
}

if (typeof IB === 'undefined') {
  window.IB = {}
}

if (IB.formUtagEvents === undefined) {
  window.IB.formUtagEvents = {
    init: initializeUtagEvents,
  }
}
